// extracted by mini-css-extract-plugin
export default {"root":"TableNavigation_root__oHSna","resultLabel":"TableNavigation_resultLabel__pbUGe","navButton":"TableNavigation_navButton__bCgoX","navIcon":"TableNavigation_navIcon__JuqMh"};